const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  globalDict: state => state.globalDict.globalDict,
  userName: state => state.user.userName,
  userInfo: state => state.user.userInfo,
  userInfos: state => state.user.userInfos,
  userPermission: state => state.user.userPermission,
  userBtnPermissionTree: state => state.user.userBtnPermissionTree,
  userScrollTop: state => state.user.userScrollTop,
  routes: state => state.permission.routes,
  instanceCodeOptions: state => state.screen.instanceCodeOptions,
  addRoutes: state => state.permission.addRoutes,
  areaData: state => state.user.areaData,
  deptData: state => state.user.deptData,
  menuList: state => state.app.menuList,
  equityIds: state => state.app.equityIds, // 权益id集合
  audioMsg: state => state.audio.audioMsg,
  accountPermission: state => state.user.accountPermission,
  loginUserId: state => state.user.userInfos.loginUserId,
  curStageInfo: state => state.resume.curStageInfo,
  nextStageInfo: state => state.resume.nextStageInfo,
  functionBtnList: state => state.resume.functionBtnList,
  functionBtnListByApi: state => state.resume.functionBtnListByApi,
  detailIsAllProfile: state => state.resume.detailCurrentJob === null,
  detailCurrentJob: state => state.resume.detailCurrentJob,
  tempLibraryType: state => state.resume.tempLibraryType,
  needContrlByTalentConfig: state => state.resume.needContrlByTalentConfig,
  sysJobConfig: state => state.job.sysJobConfig,
  checkUserInTalent: state => state.resume.checkUserInTalent,
  notificationCount: state => state.app.notificationCount,
  getUserDataPermission: (state) => (type, action, jobUserID) => {
    if (!jobUserID || !type || !action) {
      console.log('缺少参数jobUserID')
      return true
    }
    console.log('jobUserID', jobUserID);
    const data = state.user.userDataPermission[type][action]
    let role = true   
    if (data.dataPermissionType !== 'ALL') {
      if(Array.isArray(jobUserID)){
        let tag = false
        for (let index = 0; index < jobUserID.length; index++) {
          const element = jobUserID[index];          
          if(data.userIds.includes(element)){
            tag = true
            break;
          }
        }        
        if(!tag){
          role = false
        }
      }else{
        if(!data.userIds.includes(jobUserID)){
          role = false
        }
      }
    }
    console.log('getUserDataPermissionRole', type + '_' + action + '_' + jobUserID + ':' + role)
    return role
  },
}
export default getters
